<template>
  <sa-page-layout
    :titolo="titolo"
    :btnBackVisible="true"
    :btnEditVisible="false"
    :linkback="linkback"
    :linkedit="linkedit"
    :pathResource="pathResource"
    :data="jsonData"
    :showModalLoading="showModalLoading"
    class="sa-no-space"
  >
    <template slot="table-body">
      <div class="sa-tab-scroll">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Versioni</label>
            <b-form-select
              v-model="versioning"
              :options="itemsVersioning"
              @change="onChangeVersione(versioning)"
              :value="null"
              value-field="id"
              :disabled="false"
              text-field="value"
            >
              <template #first>
                <b-form-select-option :disabled="true" :value="null"
                  >- Seleziona Versione -</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col class="mt-3" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Struttura</label>
            <span class="sa-data">{{ jsonData.codiceStruttura }}</span>
          </b-col>
          <b-col class="text-left" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Stato</label>
            <span class="sa-data">{{ jsonData.stato }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Creazione</label>
            <span class="sa-data">{{  jsonData.createDate ? formatDate(jsonData.createDate)  : ""}}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Utente creazione</label>
            <span class="sa-data">{{ jsonData.createUser }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Aggiornamento</label>
            <span class="sa-data">{{ jsonData.updateDate ? formatDate(jsonData.updateDate)  : ""}}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Utente aggiornamento</label>
            <span class="sa-data">{{ jsonData.updateUser }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Report Name</label>
            <span class="sa-data">{{ jsonData.reportName }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Nome File</label>
            <span class="sa-data">{{ jsonData.nomeFile }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Descrizione</label>
            <span class="sa-data">{{ jsonData.descrizione }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
            <label class="sa-label-data">JsonData</label>
            <b-button
                size="sm"
                v-b-tooltip.hover
                title="Info"
               
                variant="outline-primary"
                @click="onClickInfoJsonData(jsonData)"
              >
                <font-awesome-icon icon="info-circle" />
              </b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row
              class="sa-label-info"
              style="margin-left: 0.5rem; margin-right: 0.5rem"
            >
              <b-col cols="6" lg="3">
                <p>{{ "Record Totali" }}: {{ totalRowsSubReportView }}</p>
              </b-col>
              <b-col cols="6" lg="9">
                <b-pagination
                  v-model="currentPageSubReportView"
                  :total-rows="totalRowsSubReportView"
                  :per-page="perPageSubReportView"
                  align="right"
                  size="sm"
                ></b-pagination>
              </b-col>
            </b-row>
        <b-row class="mt-3 pa-6">
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <b-card class="sa-card sa-card-border" header="Sub Reports" header-tag="header" footer-tag="footer" title="">
                <template #header>
                  <b-row>
                    <b-col class="text-left" cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                      <span>Sub Report</span>
                    </b-col>
                    <b-col class="text-right" cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                      <b-button  size="sm"  :disabled="disabledForVersioning" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAggiungiNuovoFileSubReport()" >
                        <b-icon icon="upload"></b-icon>
                    </b-button>    
                    <b-button  size="sm"  :disabled="disabledForVersioning" variant="btn btn-outline-success waves-effect waves-light width-sm no-text"  @click="onChooseRecordSubReport()">
                        <b-icon icon="plus"></b-icon>
                    </b-button>
                    </b-col>
                  </b-row>
                </template>
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="itemsSubReport" :fields="fieldsSubReport" :current-page="1" :per-page="5" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(actions)="row">
                  <b-container class="bv-example-row">
                  <b-button v-if="row.item.stato != 'DEPRECATO'"
                   size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAggiungiSubReportVersione(row.item)">
                    <font-awesome-icon icon="plus" />
                  </b-button>
                </b-container>
          
                  <!-- 
                    <b-button size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text">
                        <b-icon icon="trash"></b-icon>
                    </b-button> -->
                </template>
            </b-table>
        </b-card>
          </b-col>
        </b-row>
      </div>
      <b-modal ref="mdlChooseRecordSubReport" title="Selezionare Record Sub Report" size="lg" style="height: 100%" centered>
        <b-row
              class="sa-label-info"
              style="margin-left: 0.5rem; margin-right: 0.5rem"
            >
              <b-col cols="6" lg="3">
                <p>{{ "Record Totali" }}: {{ AllSubReportRowsNumber }}</p>
              </b-col>
              <b-col cols="6" lg="9">
                <b-pagination
                  v-model="AllSubReportCurrentPage"
                  :total-rows="AllSubReportRowsNumber"
                  :per-page="AllSubReportperPage"
                  align="right"
                  size="sm"
                ></b-pagination>
              </b-col>
            </b-row>
        <b-card class="sa-card sa-card-border"  header="Sub Reports" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" selectable select-mode="single" @row-selected="onRowSelected" stacked="lg" striped hover :items="AllSubReports" :fields="fieldsSubReportChoosenTable" :current-page="1" :per-page="5" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
              <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
    
            </b-table>
        </b-card>
        <template #modal-footer>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Annulla"
            variant="outline-danger"
            @click="onCloseModalChooseRecordSubReport()"
          >
          Annulla
            <!-- <font-awesome-icon icon="reload" /> -->
          </b-button>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Seleziona SubReport"
            variant="outline-info"
            @click="onSelezionaSubReportSelezionato()"
          >
          Seleziona e Salva
            <!-- <font-awesome-icon icon="reload" /> -->
          </b-button>
        </template>
    </b-modal>
      <b-modal ref="mdlJsonDataModifica" title="Modifica JsonData" size="xs" style="height: 100%" centered  >
      <template #modal-footer>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Modifica JSONData"
            variant="outline-info"
            @click="onModificaJsonData()"
             :disabled="disabledForVersioning"
          >
          Modifica
            <!-- <font-awesome-icon icon="reload" /> -->
          </b-button>
        </template>
        <label class="sa-label-data">Validità JSON : <font-awesome-icon icon="times-circle" style="color: #C82333 !important;"  v-if="jsonError" />    <font-awesome-icon  style="color: #218838 !important;" icon="check-circle" v-else /></label>
        <b-form-textarea
              no-resize
              rows="20"
              v-model="jsonData.testData"
            ></b-form-textarea>
    </b-modal>
    </template>

  </sa-page-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  mixins:[UtilityMixin],
  components: { SaPageLayout },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.linkedit = "/printserver/edit/" + me.id;
    me.loadData();
   
  },
  data() {
    return {
      itemsVersioning:[],
      versioning : null,
      titolo: "Print Server View",
      pathResource: "/printserver",
      linkback: "/printserver",
      jsonError:false,
      isAggiungiSubReport:false,
      listKey: 0,
      selectedRowDetail: null,
      id: "",
      subReportSelected: [],
      storicoSubReport:[],
      linkedit: null,
      itemsSubReport:[],
      disabledForVersioning:false,
      currentPageSubReportView:1,
      rowsSubReportView:20,
      perPageSubReportView:5,
      totalRowsSubReportView:0,
      fieldsSubReport:[
      {
          label: "Report Name",
          key: "reportName",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "File",
          key: "nomeFile",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Desrizione",
          key: "descrizione",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Versioni",
          key: "versione",
          sortable: true,
          //thStyle: "width: 12rem",
        },
        {
          label: "Ultima Modifica",
          key: "updateDate",
          sortable: true,
          formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY hh:mm");
                        } else {
                            return "-----";
                        }
                    },
          //thStyle: "width: 12rem",
        },
        {
          label: "Stato",
          key: "stato",
          sortable: true,
          //thStyle: "width: 12rem",
        },

        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],

      AllSubReports:[],
      AllSubReportRowsNumber:0,
      AllSubReportCurrentPage:1,
      AllSubReportperPage:5,

      fieldsSubReportChoosenTable:[
      {
          label: "",
          key:  'selected',
          sortable: false,
          thStyle: "width: 5rem",
          class: "text-left",
        },
       
      {
          label: "Report Name",
          key: "reportName",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "File",
          key: "nomeFile",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Descrizione",
          key: "descrizione",
          sortable: false,
          //thStyle: "width: 4rem",
          class: "text-left",
        },
        {
          label: "Versioni",
          key: "versione",
          sortable: true,
          //thStyle: "width: 12rem",
        },
        {
          label: "Ultima Modifica",
          key: "updateDate",
          sortable: true,
          formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY hh:mm");
                        } else {
                            return "-----";
                        }
                    },
          //thStyle: "width: 12rem",
        },
        {
          label: "Stato",
          key: "stato",
          sortable: true,
          //thStyle: "width: 12rem",
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
      expadedTestData: false,
      showModalLoading: false,
      elementsSubReport:[],
      jsonData: {
        subReport: [],
      },
    };
  },
  methods: {
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
      me.showModalLoading = true;
      axios.get(link + me.id).then((response) => {
        me.jsonData = response.data.data;
        this.loadSubReport(me.jsonData.id);
        me.loadDataForVersioning(me.jsonData.reportName);
        me.versioning = me.jsonData.id;
        me.showModalLoading = false;
      });
    },
    loadDataById(id) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
      me.showModalLoading = true;
      axios.get(link + id).then((response) => {
        me.jsonData = response.data.data;
        me.versioning = me.jsonData.id;
        me.disabledForVersioning = false;
        this.loadSubReport(me.jsonData.id);
        me.loadDataForVersioning(me.jsonData.reportName);
        if(me.jsonData.stato === "DEPRECATO"){
          me.disabledForVersioning = true;
        }
        me.showModalLoading = false;
      });
    },
    onChangeVersione(value){
      let me = this;
      me.loadDataById(value);
    },
    loadDataForVersioning(reportName) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      me.showModalLoading = true;
      let filtro = {
        nomeReport: reportName,
        forPage:100,
        page:1,
        struttura: me.jsonData.codiceStruttura
      }
      axios.get(link,{ params: filtro }).then((response) => {
        me.itemsVersioning = [];
        if(response.data.data.list.length >0){
       
          for(let a of response.data.data.list){
            me.itemsVersioning.push({
              text:a.versione,
              value:a.versione,
              id:a.id
            })  
          }
        }
      
        me.showModalLoading = false;
      });
    },
    formatDate(value){
      return UtilityMixin.methods.formatDateTimeCustom(value,"DD/MM/YYYY hh:mm")
    },
    onChooseRecordSubReport(){
      let me = this;
      me.$refs.mdlChooseRecordSubReport.show();
      me.AllSubReports = [];
      me.loadAllSubReport("ATTIVO");
    },
    onAggiungiSubReportVersione(item){
      console.log(item);
      let me = this;
      me.$router.push({path:"/printserversubreport/edit/"+item.id})
      let master = {
        reportMaster:me.jsonData.id,
        reportName:me.jsonData.reportName,
        struttura:me.jsonData.codiceStruttura
      }
      sessionStorage.setItem("reportMaster",JSON.stringify(master));
    },
    onRowSelected(items) {
        let me = this;
        me.subReportSelected = items;
      },
    onAggiungiNuovoFileSubReport(){
      let me = this;
      me.$router.push({path:"/printserversubreport/edit/-1"})
      let master = {
        reportMaster:me.jsonData.id,
        reportName:me.jsonData.reportName,
        struttura:me.jsonData.codiceStruttura
      }
      sessionStorage.setItem("reportMaster",JSON.stringify(master));
    },
    loadSubReport(id) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/printserversubreport";
      me.showModalLoading = true;
      let filtro = {
        forPage: me.perPageSubReportView,
        page: me.currentPageSubReportView,
        idReportMaster:id,
        stato:'ATTIVO'
      }
      axios.get(link, { params: filtro }).then((response) => {
        me.itemsSubReport = [];
        me.itemsSubReport = response.data.data.list;
        me.totalRowsSubReportView = response.data.data.recordsNumber;
        me.showModalLoading = false;
      });
    },
    loadAllSubReport(stato) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/printserversubreport";
      me.showModalLoading = true;
      
      let filtro = {
        forPage: me.AllSubReportperPage,
        page: me.AllSubReportCurrentPage,
        stato: stato
      }
      axios.get(link, { params: filtro }).then((response) => {
        me.AllSubReports = [];
        me.AllSubReports = response.data.data.list;
        me.AllSubReportRowsNumber = response.data.data.recordsNumber;
        const filteredArray = me.AllSubReports.filter(a =>
          !me.itemsSubReport.some(b => a.nomeFile	 === b.nomeFile)
        );
        me.AllSubReports = filteredArray;
        me.showModalLoading = false;
      });
    },
    onCloseModalChooseRecordSubReport(){
      let me = this;
      me.clearSubReportSelezionato();
      me.subReportSelected = [];
      me.$refs.mdlChooseRecordSubReport.hide();
    },
    clearSubReportSelezionato() {
      let me = this;
      me.$refs.mdlChooseRecordSubReport.clearSelected;
    },
    onSelezionaSubReportSelezionato(){
      let me = this;
      console.log(me.subReportSelected);
      me.subReportSelected[0].id = "-1";
      me.subReportSelected[0].primaryKey ="-1";
      me.subReportSelected[0].idReportMaster = me.jsonData.id;
      me.subReportSelected[0].copy = true;
      me.subReportSelected[0].strutturaCopy = me.jsonData.codiceStruttura;
      me.salvaSubReportCopia(me.subReportSelected);
      me.onCloseModalChooseRecordSubReport();
      me.loadData();
    },
    salvaSubReportCopia(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API +"/printserversubreport";
      me.showModalLoading = true;
      let sendObj = item[0];
      console.log(sendObj);
      console.log(link);
      
      axios.post(link ,sendObj).then((response) => {
        me.jsonData = response.data.data;
        me.showModalLoading = false;

      });
    },
    onModificaJsonData(){
        let me = this;
        me.showModalLoading = true;
      let linkReport = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id;
      axios
        .put(linkReport, me.jsonData)
        .then((response) => {
          me.jsonData = response.data.data;
          me.$refs.mdlJsonDataModifica.hide();
          me.showModalLoading = false;
        }).catch((erro)=>{
            console.log(erro);
            me.showModalLoading = false;
        });
    },
    onClickInfoJsonData(){
        let me = this;
        me.$refs.mdlJsonDataModifica.show();
    }
  },
  watch: {
    "jsonData.testData": function (params) {
      let me = this;
      try {
        JSON.parse(params);
        me.jsonError = false; 
      } catch (e) {
        me.jsonError = true; 
      }
    },
    currentPageSubReportView() {
      let me = this;
      me.loadData();
    },
    AllSubReportCurrentPage() {
      let me = this;
      me.loadAllSubReport("ATTIVO");
    },
  
  },
};
</script>
